"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwimLane = void 0;
var _react = require("react");
var _hooks = require("../../hooks");
var _ArrowButton = require("./partials/ArrowButton");
var _SwimLane = require("./SwimLane.labels");
var _SwimLane2 = _interopRequireDefault(require("./SwimLane.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SwimLane = function SwimLane(props) {
  var _props$items = props.items,
    items = _props$items === void 0 ? [] : _props$items,
    maxNumberOfItems = props.maxNumberOfItems,
    _props$slideBy = props.slideBy,
    slideBy = _props$slideBy === void 0 ? 'item' : _props$slideBy;
  var itemsToDisplay = (0, _react.useMemo)(function () {
    return !maxNumberOfItems || maxNumberOfItems > items.length ? items : items.slice(0, maxNumberOfItems);
  }, [items, maxNumberOfItems]);
  var containerRef = (0, _react.useRef)(null);
  var innerContainerRef = (0, _react.useRef)(null);
  var isMoving = (0, _react.useRef)();
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    swimLaneDirection = _useState2[0],
    setSwimLaneDirection = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLeftButtonVisible = _useState4[0],
    setIsLeftButtonVisible = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isRightButtonVisible = _useState6[0],
    setIsRightButtonVisible = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    translateX = _useState8[0],
    setTranslateX = _useState8[1];
  var _useState9 = (0, _react.useState)(0),
    _useState10 = _slicedToArray(_useState9, 2),
    translateDelta = _useState10[0],
    setTranslateDelta = _useState10[1];
  var getLabel = (0, _hooks.useLabels)({
    labels: _SwimLane.labels
  });
  var styles = (0, _SwimLane2.default)(slideBy);
  var calcItemWidth = (0, _react.useCallback)(function () {
    var _innerContainerRef$cu, _innerContainerRef$cu2;
    if ((_innerContainerRef$cu = innerContainerRef.current) !== null && _innerContainerRef$cu !== void 0 && (_innerContainerRef$cu2 = _innerContainerRef$cu.children) !== null && _innerContainerRef$cu2 !== void 0 && _innerContainerRef$cu2.length) {
      var firstChild = innerContainerRef.current.firstElementChild;
      if (firstChild) {
        var _firstChild$firstElem;
        var boundingClientRect = firstChild.getBoundingClientRect();
        var innerBoundingClientRect = (_firstChild$firstElem = firstChild.firstElementChild) === null || _firstChild$firstElem === void 0 ? void 0 : _firstChild$firstElem.getBoundingClientRect();
        return {
          totalWidth: boundingClientRect.width,
          innerWidth: innerBoundingClientRect ? innerBoundingClientRect.width : boundingClientRect.width,
          margin: innerBoundingClientRect !== null && innerBoundingClientRect !== void 0 && innerBoundingClientRect.width ? boundingClientRect.width - innerBoundingClientRect.width : 0
        };
      }
    }
    return undefined;
  }, []);
  var handleMoveLeft = function handleMoveLeft() {
    var _innerContainerRef$cu3, _innerContainerRef$cu4;
    if (isMoving.current) return;
    if (swimLaneDirection && containerRef.current && (_innerContainerRef$cu3 = innerContainerRef.current) !== null && _innerContainerRef$cu3 !== void 0 && _innerContainerRef$cu3.firstElementChild && (_innerContainerRef$cu4 = innerContainerRef.current) !== null && _innerContainerRef$cu4 !== void 0 && _innerContainerRef$cu4.lastElementChild) {
      var currentLeft = containerRef.current.getBoundingClientRect().left;
      var minLeft = swimLaneDirection === 'ltr' ? innerContainerRef.current.firstElementChild.getBoundingClientRect().left : innerContainerRef.current.lastElementChild.getBoundingClientRect().left;
      var newTranslateVal = translateX + translateDelta;
      if (minLeft <= currentLeft) {
        isMoving.current = true;
        setTranslateX(newTranslateVal);
        setIsRightButtonVisible(true);
        setIsLeftButtonVisible(Math.round(minLeft + translateDelta) < Math.round(currentLeft));
      } else {
        setIsLeftButtonVisible(false);
      }
    }
  };
  var handleMoveRight = function handleMoveRight() {
    var _innerContainerRef$cu5, _innerContainerRef$cu6;
    if (isMoving.current) return;
    if (swimLaneDirection && containerRef.current && (_innerContainerRef$cu5 = innerContainerRef.current) !== null && _innerContainerRef$cu5 !== void 0 && _innerContainerRef$cu5.firstElementChild && (_innerContainerRef$cu6 = innerContainerRef.current) !== null && _innerContainerRef$cu6 !== void 0 && _innerContainerRef$cu6.lastElementChild) {
      var currentRight = containerRef.current.getBoundingClientRect().right;
      var maxRight = swimLaneDirection === 'ltr' ? innerContainerRef.current.lastElementChild.getBoundingClientRect().right : innerContainerRef.current.firstElementChild.getBoundingClientRect().right;
      var newTranslateVal = translateX - translateDelta;
      if (currentRight <= maxRight) {
        isMoving.current = true;
        setTranslateX(newTranslateVal);
        setIsLeftButtonVisible(true);
        setIsRightButtonVisible(Math.round(currentRight + translateDelta) < Math.round(maxRight));
      } else {
        setIsRightButtonVisible(false);
      }
    }
  };
  (0, _react.useEffect)(function () {
    if (slideBy === 'scroll') {
      setIsLeftButtonVisible(false);
      setIsRightButtonVisible(false);
      setTranslateX(0);
    } else {
      var itemWidth = calcItemWidth();
      if (itemWidth !== null && itemWidth !== void 0 && itemWidth.totalWidth && itemsToDisplay.length > 0 && containerRef.current && innerContainerRef.current) {
        var _innerContainerRef$cu7;
        var computedStyle = window.getComputedStyle(containerRef.current);
        var containerWidth = Number(computedStyle.width.replace('px', ''));
        var contentWidth = itemWidth.totalWidth * itemsToDisplay.length;
        if (slideBy === 'item') {
          setTranslateDelta(contentWidth <= containerWidth ? 0 : itemWidth.totalWidth);
        } else if (slideBy === 'page') {
          setTranslateDelta(contentWidth <= containerWidth ? 0 : containerWidth);
        }
        var lastItemElement = (_innerContainerRef$cu7 = innerContainerRef.current) === null || _innerContainerRef$cu7 === void 0 ? void 0 : _innerContainerRef$cu7.lastElementChild;
        if (lastItemElement) {
          if (computedStyle.direction !== 'ltr') {
            var containerLeft = containerRef.current.getBoundingClientRect().left;
            var lastItemLeft = lastItemElement.getBoundingClientRect().left;
            setIsLeftButtonVisible(lastItemLeft + itemWidth.margin < containerLeft - itemWidth.margin);
          } else {
            var containerRight = containerRef.current.getBoundingClientRect().right;
            var lastItemRight = lastItemElement.getBoundingClientRect().right;
            setIsRightButtonVisible(lastItemRight > containerRight);
          }
        }
        setSwimLaneDirection(computedStyle.direction);
      }
    }
  }, [slideBy, itemsToDisplay.length, containerRef, innerContainerRef, calcItemWidth]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: containerRef,
    className: styles['cc-SwimLane'],
    children: (itemsToDisplay === null || itemsToDisplay === void 0 ? void 0 : itemsToDisplay.length) > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [isLeftButtonVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowButton.ArrowButton, {
        direction: "left",
        label: swimLaneDirection === 'ltr' ? getLabel('previous') : getLabel('next'),
        onClick: handleMoveLeft
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ref: innerContainerRef,
        className: styles['cc-SwimLane__items'],
        onTransitionEnd: function onTransitionEnd() {
          isMoving.current = false;
        },
        style: {
          transform: "translateX(".concat(translateX, "px)")
        },
        children: itemsToDisplay.map(function (item, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-SwimLane__item'],
            children: item
          }, index);
        })
      }), isRightButtonVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowButton.ArrowButton, {
        direction: "right",
        label: swimLaneDirection === 'ltr' ? getLabel('next') : getLabel('previous'),
        onClick: handleMoveRight
      })]
    })
  });
};
exports.SwimLane = SwimLane;